import React, { useMemo } from 'react';
import 'jspdf-autotable';
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import tableIcons from "./components/MaterialTableIcons";

const useStyles = makeStyles({
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
  },
  title: {
    fontSize: '2em'
  }
});

const theme = createTheme({
  typography: { h6: { fontSize: '1.4em' } },
});

const numberWithCommas = (x) => {
  if (x === null || x === undefined || x === "") return "0.00";
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
};

const toMoneyNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;

  const cleaned = String(value).replace(/[$,]/g, "").trim();
  const parsed = Number.parseFloat(cleaned);

  if (Number.isNaN(parsed)) return 0;
  return Number(parsed.toFixed(2));
};

const InvoiceList = (inputs) => {
  const normalizedRows = useMemo(() => {
    const rows = Array.isArray(inputs.data) ? inputs.data : [];

    return rows.map((row) => {
      const referenceValue =
        row.ref_no ||
        row.ref ||
        row.reference ||
        row.Reference ||
        "";

      const paymentIdValue =
        row.payment_id ||
        row.Payment_ID ||
        "";

      const paymentDateValue =
        row.payment_date ||
        row.Paid_Date ||
        row.Date_Paid ||
        "";

      const paymentAmountValue =
        row.payment_amt ||
        row.pay_amt ||
        row.Pay_Amt ||
        0;

      return {
        ...row,


        // MaterialTable Reference # column reads ref_no,
        // but backend payment_history stores it as ref/reference.
        ref_no: referenceValue,

        payment_id: paymentIdValue,
        payment_date: paymentDateValue,
        payment_amt: paymentAmountValue,
      };
    });
  }, [inputs.data]);

  const totalAmount = useMemo(() => {
    if (inputs.sum !== undefined && inputs.sum !== null && inputs.sum !== "") {
      return toMoneyNumber(inputs.sum);
    }

    return normalizedRows.reduce((total, row) => {
      return total + toMoneyNumber(row.payment_amt);
    }, 0);
  }, [inputs.sum, normalizedRows]);

  const columns = [
    {
      title: 'Reference #',
      field: 'ref_no',
      cellStyle: { fontSize: '1em' },
      editable: 'never',
      render: (rowData) => (
        <div>
          {rowData.ref_no || ""}
        </div>
      ),
    },

    {
      title: 'Date',
      field: 'payment_date',
      cellStyle: { fontSize: '1em' },
      editable: 'never',
    },

    {
      title: 'Pay Amt',
      field: 'payment_amt',
      render: (rowData) => (
        <div>
          {numberWithCommas(toMoneyNumber(rowData.payment_amt).toFixed(2))}
        </div>
      ),
      cellStyle: { fontSize: '1em' },
      editable: 'never',
    },

    {
      title: 'Payment ID',
      field: 'payment_id',
      cellStyle: { fontSize: '1em' },
      editable: 'never',
      render: (rowData) => (
        <div>
          {rowData.payment_id || ""}
        </div>
      ),
    },
  ];

  return (
    <div className="InvoiceList">
      <h1 align="center">Invoice List</h1>

      <ThemeProvider theme={theme}>
        <MaterialTable
          title={"Invoice # : " + inputs.inv_num}
          icons={tableIcons}
          columns={columns}
          data={normalizedRows}
          options={{
            sorting: true,
            search: false,
            searchFieldAlignment: "left",
            searchAutoFocus: true,
            searchFieldVariant: "outlined",
            filtering: false,
            paging: true,
            pageSizeOptions: [2, 5, 10, 15, 77],
            pageSize: 5,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: {
              csv: true,
            },
            exportAllData: true,
            exportFileName: "Payment_Summary",
            addRowPosition: "first",
            actionsColumnIndex: -1,
            selection: false,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            grouping: false,
            columnsButton: true,
            rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
            headerStyle: {
              background: "lightgray",
              fontStyle: "italic",
              fontSize: 19,
            },
          }}
        />
      </ThemeProvider>

      <h2>
        Total Amount : {numberWithCommas(totalAmount.toFixed(2))}-{inputs.currency}
      </h2>
    </div>
  );
};

export default InvoiceList;